/**
 * Supabase project URL helpers — avoid `https://host//storage/...` when env has a trailing slash.
 */

/** Trim and strip trailing slashes from the project URL (e.g. VITE_SUPABASE_URL). */
export function normalizeSupabaseProjectUrl(url: string): string {
  return url.trim().replace(/\/+$/, "");
}

/**
 * Fix double slash after host in public Storage URLs (e.g. from bad env or legacy HTML).
 * Example: `https://xxx.supabase.co//storage/v1/...` → `https://xxx.supabase.co/storage/v1/...`
 */
export function fixSupabasePublicStorageUrl(url: string): string {
  if (!url) return url;
  return url.replace(/(https?:\/\/[^/]+)\/\/+(?=storage\/)/i, "$1/");
}
